import { createDecorator } from 'vue-class-component'

export const Log = createDecorator((options, key, index) => {
  const originalMethod = options.methods[key]
  options.methods[key] = function wrappedMethod(...args) {
    console.log(`Invoked ${key}(`, ...args, `)`)
    originalMethod.apply(this, args)
  }
})

export const Reactive = state => {
  return createDecorator((options, key) => {
    const originalCreated = options.created
    options.created = function() {
      if (!!originalCreated) {
        originalCreated.apply(this)
      }
      if (typeof state[key] === 'undefined') {
        throw ReferenceError(`state中不存在${key}属性`)
      } else {
        state[key].subscribe(res => {
          this[key] = res
        })
      }
    }
  })
}

// export const Action = (actions: { [name: string]: (...arg: any[]) => any }[]) => {
//   return createDecorator((options, key) => {
//     const originalMethod = options.methods[key]
//     options.methods[key] = function(...args) {
//       originalMethod.apply(this, args)
//       if (!!actions[key] && typeof actions[key] === 'function') {
//         actions[key].apply(this, args)
//       } else {
//         throw ReferenceError(`actions中不存在${key}方法`)
//       }
//     }
//   })
// }
